import React from "react";
import { Box, Typography } from "@mui/material";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions"; // temporary icon
import handCursor from '../../../assets/hand-cursor.png'
import warnring from '../../../assets/warnring.png'


const BalanceInfoBanner = ({vmInventory}) => {
  return (
    <>
{/*     {true?
      <Box sx={{padding:"10px"}}>
    <Box
      sx={{
        backgroundColor: "#FFF9E0", // soft yellow
        border: "2px dashed #FBE240", // subtle dotted yellow border
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        px: 2,
        py: 1.5,
        width: "100%",
        boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
        marginTop:"50px"
      }}
    >
      <Box
        component="img"
        src={handCursor}// temporary hand icon
        alt="hand icon"
        sx={{ width: 50, height: 50 }}
      />
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          color: "#4B2E1E",
          fontSize: "14px",
          textAlign: "center",
        }}
      >
        With Your Available Balance, You Can Pick {vmInventory&&vmInventory.length} Items
      </Typography>
    </Box>
    </Box>:  
    <Box sx={{padding:"10px"}}>
    <Box
      sx={{
        backgroundColor: "#E2272733", // soft yellow
        border: "2px dashed #E227274D", // subtle dotted yellow border
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        px: 2,
        py: 1.5,
        width: "100%",
        boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
        marginTop:"50px"
      }}
    >
      <Box
        component="img"
        src={warnring}// temporary hand icon
        alt="hand icon"
        sx={{ width: 30, height: 30 }}
      />
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          color: "#4B2E1E",
          fontSize: "14px",
          textAlign: "center",
        }}
      >
       Need ₹5 more to unlock these snacks
      </Typography>
    </Box>
    </Box>} */}
    </>
  );
};

export default BalanceInfoBanner;
